import { useUser } from '#/contexts/UserEnvironmentContext';

export function useUserPostAListingHref() {
  const { user } = useUser();

  if (user?.orgs.length === 1) {
    const [org] = user.orgs;
    if (org.isAllowedToPost && !org.isFrozen) {
      return `/admin/${org.id}/post-a-listing`;
    }

    return `/admin/${org.id}`;
  }

  return '/post-a-listing';
}
